export enum guestCapacity {
  ADULTS = 20,
  CHILDREN = 20,
  INFANTS = 5,
  PETS = 2,
}
